const PHONE_NUMBER_LENGTH = 10;

export function parseRawNumber(phone: string): string {
  let rawPhoneNumber = phone.replace(/[^0-9]/ig, '');
  const offset = rawPhoneNumber.length - PHONE_NUMBER_LENGTH;

  rawPhoneNumber = rawPhoneNumber.substring(offset, rawPhoneNumber.length);

  return rawPhoneNumber;
}

/**
 * format the given phone number `1111111111` to `(111) 111-1111`
 * @param {String} phone number
 */
export default function formatPhoneNumber(phone) {
  const rawPhoneNumber = parseRawNumber(phone);

  return `(${rawPhoneNumber.slice(0, 3)}) ${rawPhoneNumber.slice(3, 6)}-${rawPhoneNumber.slice(6, 10)}`;
}
